import { ChangeDetectionStrategy, Component, ViewEncapsulation, booleanAttribute, input } from '@angular/core';
import { M000C010ImageComponent } from '../../000-primitives/m000-c010-image/m000-c010-image.component';
import { ImageAiFocus } from '../../000-primitives/m000-c010-image/m000-c010-image.interface';
import { M000C050VideoComponent } from '../../000-primitives/m000-c050-video/m000-c050-video.component';
import { M040C030BadgeComponent } from '../../040-content-structure/m040-c030-badge/m040-c030-badge.component';

@Component({
    selector: 'ui-m030-c110-model-hero',
    standalone: true,
    templateUrl: './m030-c110-model-hero.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [M000C010ImageComponent, M040C030BadgeComponent, M000C050VideoComponent],
})
export class M030C110ModelHeroComponent {
    title = input<string>();
    text = input<string>();
    image = input.required<{ url: string; alt?: string | null }>();
    logoImages = input<Array<{ url: string; alt?: string | null }>>();
    isAvailable = input(false, { transform: booleanAttribute });
    isFirstView = input.required({ transform: booleanAttribute });
    videoUrl = input<string>();

    ImageAiFocus = ImageAiFocus;
}
